import IssuerListContainer from '../helpers/IssuerListContainer';

class IdealElement extends IssuerListContainer {
    public static type = 'ideal';
}

export default IdealElement;
